import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { DataProvider } from "./src/utils/Context/DataContext";
import "@fortawesome/fontawesome-free/css/all.min.css";

//css
import "./src/assets/libraries/bootstrap/css/bootstrap.min.css";
import "./src/assets/libraries/fontawesome/css/all.min.css";
import "./src/assets/css/style.css";

//js
// import "./src/assets/libraries/bootstrap/js/bootstrap.js";

//Component
import MainLayout from "./src/components/MainLayout/MainLayout";

// pages
import Home from "./src/pages/Home/Home";

import AddWorkExperience from "./src/components/AddWorkExperience/AddWorkExperience";

import Dashboard from "./src/pages/Dashboard/Dashboard";
import Activity from "./src/pages/Activity/Activity";
import Profile from "./src/pages/Profile/Profile";
import Notification from "./src/pages/Notification/Notification";
import SearchPage from "./src/pages/SearchPage/SearchPage";
import Company from "./src/pages/Company/Company";
import TaskView from "./src/pages/TaskView/TaskView";
import CompanyView from "./src/pages/CompanyView/CompanyView";
import CompanyJoinInvitition from "./src/pages/CompanyJoinInvitition/CompanyJoinInvitition";
import CompanyWorkInvitition from "./src/pages/CompanyWorkInvitition/CompanyWorkInvitition";
import CreateAccount from "./src/pages/CreateAccount/CreateAccount";
import UserSkills from "./src/components/UserSkills/UserSkills";

//
import Loader from "./src/utils/Loader";
import { usePromiseTracker } from "react-promise-tracker";
import { Toaster } from "react-hot-toast";

export default function App() {
  useEffect(() => {
    console.log("App On mount :");
  }, []);

  return (
    <DataProvider>
      <Loader promiseTracker={usePromiseTracker} />
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        toastOptions={{
          className: "",
          style: {
            border: "1px solid #171546",
            padding: "10px",
          },
          duration: 2500,
        }}
      />
      <BrowserRouter>
        <QueryParamProvider ReactRouterRoute={RouteAdapter}>
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/" element={<MainLayout />}>
              <Route path="/create_account" element={<CreateAccount />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/activity" element={<Activity />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/notification" element={<Notification />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/company/:company_id" element={<Company />} />
              <Route path="/task_view/:task_id" element={<TaskView />} />
              <Route path="/company_view" element={<CompanyView />} />
              <Route
                path="/join_invite/:join_id"
                element={<CompanyJoinInvitition />}
              />
              <Route
                path="/work_invite/:company_id/:work_id"
                element={<CompanyWorkInvitition />}
              />
              <Route path="/add_experience" element={<AddWorkExperience />} />
              <Route path="/skills" element={<UserSkills />} />
            </Route>
          </Routes>
        </QueryParamProvider>
      </BrowserRouter>
    </DataProvider>
  );
}

function RouteAdapter({ children }: any) {
  const navigate = useNavigate();
  const location = useLocation();

  const adaptedHistory = React.useMemo(
    () => ({
      replace(location: any) {
        navigate(location, { replace: true, state: location.state });
      },
      push(location: any) {
        navigate(location, { replace: false, state: location.state });
      },
    }),
    [navigate]
  );
  return children({ history: adaptedHistory, location });
}
